module.exports = __webpack_public_path__ + "img/23-6.8d83bcd9.png";